import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";

const CircleProgressBar = ({
    days,
    size = 40,
    color = "#D3E205"
}) => {
    const FULL_CIRCLE_VALUE = 30;
    const STROKE_WIDTH = 3;

    const radius = (size - STROKE_WIDTH) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (days / FULL_CIRCLE_VALUE) * circumference;

    const transformDegree = `rotate(-90 ${size / 2} ${size / 2})`;

    return (
        <svg width={size} height={size}>
            <circle
                fill="none"
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke={color}
                strokeWidth={STROKE_WIDTH}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                transform={transformDegree}
            />

            <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dy=".3em"
                fontSize="18"
                fontWeight={800}
                fill="#D3E205"
                fontFamily={FontEnum.TITILIUM_WEB}
            >
                {days}
            </text>
        </svg>
    );
};

export default CircleProgressBar;